import request from '../lib/request.js';

import HOSTS from '../config.js'

const BSEURL = `${HOSTS.login}/sso/external`;

export default {
  /**
   * 对外登录
   * @param params {username, password}
   * @returns {*}
   */
  login: params => request.post(`${BSEURL}/login`, params),
  /**
   * 获取图片(极验)
   * @param params {}
   * @returns {*}
   */
  createSlideCaptcha: params => request.post(`${BSEURL}/createSlideCaptcha`, params),
  /**
   * 获取图片验证码
   * @param params {}
   * @returns {*}
   */
  creatCaptcha: params => request.post(`${BSEURL}/createCaptcha`, params),

  /**
   * 发送短信验证码(对外)
   * @param params  {mfaTempToken}
   * @returns {*}
   */
  sendSmsCode: params => request.post(`${BSEURL}/sendSmsCode`, params),
  /**
   * 携带验证码进行登录(对外)
   * @param params
   * @returns {*}
   */
  loginBySms: params => request.post(`${BSEURL}/loginBySms`, params),
  /**
   * TOTP登录
   * @param params
   * @returns {*}
   */
  loginByTotp: params => request.post(`${BSEURL}/loginByTotp`, params),
  /**
   * 退出
   * @param params
   * @returns {*}
   */
  logout: params => request.get(`${BSEURL}/logout`, params)
}
